import { lazy } from 'react';

const NotFound = lazy(() => import('@pages/404/NotFound'));
const homeRoute = [
    {
        path: "/404",
        name: '404',
        component: NotFound
    }
]
export default homeRoute